import { LotActivityStatus } from '../../core/constants'
import { type LotModel } from '../../modules/public/models/lot.model'
import { LotHelper } from '../../modules/manage/saleyard/helpers/LotHelper'

export type BuyerBidStatus = 'lead' | 'outbid' | 'none'

export function getBuyerBidStatusKey(lot: LotModel | null | undefined): BuyerBidStatus {
    if (
        !lot ||
        !(
            lot.activityStatus === LotActivityStatus.NowSelling ||
            lot.activityStatus === LotActivityStatus.FinishDelayed ||
            LotHelper.isInOfferState(lot)
        )
    ) {
        return 'none'
    }

    if (lot.isUsersBid) {
        return 'lead'
    }

    return lot.hasUserBid ? 'outbid' : 'none'
}
